import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-174">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-running-surface/95 backdrop-blur-md border-t border-running-muted shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" data-id="element-175">
          <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-6" data-id="element-176">
            <div className="text-center sm:text-left hidden sm:block" data-id="element-177">
              <p className="text-sm text-gray-300 font-medium" data-id="element-178">
                El sistema completo para entrenadores de running
              </p>
              <p className="text-running-blue font-bold text-lg leading-none mt-1" data-id="element-179">
                MEGA PACK RUNNING
              </p>
            </div>
            <a href="https://running-para-cambiar-vidas.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-running-blue hover:bg-running-blueHover text-running-dark font-display rounded-lg px-8 py-2.5 sm:py-3 flex flex-col items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(61,232,255,0.3)]" data-id="element-180">
              <span className="flex items-center gap-2 font-bold text-lg sm:text-xl leading-none" data-id="element-181">
                QUIERO MI PACK AHORA
                <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-182" />
              </span>
              <span className="font-bold text-xs sm:text-sm text-running-dark/80 mt-0.5" data-id="element-183">
                PRECIO DE LANZAMIENTO
              </span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}